import {Component, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomRoleDto, CustomerService} from "../../../_services/configuration-services";
import {FormControl, FormGroup} from "@angular/forms";
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-customer-export-modal',
    templateUrl: './customer-export-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerExportModalComponent {
    exportForm: FormGroup;

    constructor(public activeModal: NgbActiveModal,
                private readonly customerService: CustomerService) {

        this.exportForm = new FormGroup({
            customRoles: new FormControl<CustomRoleDto[] | null>(null)
        });
    }

    get customRolesControl(): FormControl<CustomRoleDto[] | null> {
        return this.exportForm.get('customRoles') as FormControl<CustomRoleDto[] | null>;
    }

    exportCustomers() {
        this.customerService.exportCustomers(this.customRolesControl.value ?? []).pipe().subscribe(response => {
            fileSaver.saveAs(response.data, response.fileName);
            this.activeModal.close('success');
        });
    }
}
